import e from "react";
import { c as d, t as p } from "./useKeyDown-88662051.mjs";
import { B as a } from "./useClickOutside-55c64a80.mjs";
const i = "page-header", H = "page-header--blue", m = "page-header--light-blue", u = "page-header__heading", h = "desktop", B = "page-header__lead-text", t = {
  pageHeader: i,
  pageHeaderBlue: H,
  pageHeaderLightBlue: m,
  pageHeaderHeading: u,
  desktop: h,
  pageHeaderLeadText: B
};
function E({
  heading: n,
  leadText: r,
  backgroundColor: o,
  children: g,
  className: l,
  ...s
}) {
  const c = o === "lightBlue" ? t.pageHeaderLightBlue : t.pageHeaderBlue;
  return /* @__PURE__ */ e.createElement(
    a,
    {
      "data-testid": "page-header",
      className: d(t.pageHeader, c, l),
      topPadding: a.Padding.SMALL,
      ...s
    },
    /* @__PURE__ */ e.createElement(a.Content, { itemScope: !0 }, /* @__PURE__ */ e.createElement("h1", { className: d(p.pageHeading, t.pageHeaderHeading) }, n)),
    r && /* @__PURE__ */ e.createElement(a.Content, { itemScope: !0 }, /* @__PURE__ */ e.createElement(
      "div",
      {
        className: d(
          p.textsComponentTitle,
          t.pageHeaderLeadText
        )
      },
      r
    )),
    g ? /* @__PURE__ */ e.createElement(a.Content, null, g) : null
  );
}
export {
  E as PageHeader
};
//# sourceMappingURL=PageHeader.js.map
